import { useContext } from 'react'
import { useQueryClient } from 'libs/query'
import { useNavigate } from 'libs/router'
import { AuthContext, DashboardContext, StoreSettingsContext } from 'store'

export const useLogout = () => {
	const { setAuth } = useContext(AuthContext)
	const navigate = useNavigate()
	const queryClient = useQueryClient()
	const dashboardCtx = useContext(DashboardContext)
	const storeCtx = useContext(StoreSettingsContext)

	const logout = () => {
		queryClient.removeQueries()
		setAuth({})
		dashboardCtx?.setDashboard(null)
		storeCtx?.setStoreSettings(null)
		localStorage.removeItem('refresh')
		localStorage.removeItem('showBankToast')
		navigate('/login')
	}

	return logout
}
